export default __webpack_public_path__ + "static/media/greenbrilliance-bg.125ed0a6.jpeg";